import {ReactComponent as ClarityErrorLineIcon} from './clarityErrorLine.svg'

function ClarityErrorLine() {
  return <ClarityErrorLineIcon />
}

export default ClarityErrorLine
